import { SendOutlined } from "@ant-design/icons";
import {
  AppDispatch,
  createSubjectOnBoardRemark,
  createSubjectOnBoardRemarkClear,
  createSubjectOnBoardRemarkRequest,
  getMyOrganization,
  getSubjectOnBoardAnalysis,
  getSubjectOnBoardAnalysisRequest,
} from "@src/redux";
import { Card, Input, Timeline } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { useTranslation } from "react-i18next";
import { IoMdSend } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";

type Props = {
  organizationId?: any;
};

const { TextArea } = Input;

const Remarks: React.FC<Props> = ({ organizationId }) => {
  const dispatch = useDispatch<AppDispatch>();
  const [remarks, setRemarks] = useState<string>();
  const { t } = useTranslation();
  const { result: onBoardAnalysisItems } = useSelector(
    getSubjectOnBoardAnalysis
  );
  const { result: createSubjectOnBoardRemarkStatus } = useSelector(
    createSubjectOnBoardRemark
  );
  const { result: organization } = useSelector(getMyOrganization);

  useEffect(() => {
    if (createSubjectOnBoardRemarkStatus?.status === "success") {
      setRemarks("");
      dispatch(createSubjectOnBoardRemarkClear());
      dispatch(
        getSubjectOnBoardAnalysisRequest({
          filter: {
            organizationId: organizationId || organization?.id,
          },
        })
      );
    }
  }, [createSubjectOnBoardRemarkStatus]);

  const sendRemarks = () => {
    dispatch(
      createSubjectOnBoardRemarkRequest({
        data: {
          organizationId: organizationId,
          remark: remarks || "",
        },
      })
    );
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      sendRemarks();
    }
  };
  return (
    <Card className="remarks-card">
      <div>
        <h3 className="remarks-card-title">Remarks</h3>
      </div>
      <div className="remarks-list-container">
        <Scrollbars>
          <Timeline>
            {onBoardAnalysisItems?.remarkList?.map((remark, index) => (
              <Timeline.Item
                key={index}
                color={remark?.remark ? "green" : "blue"} // Set color based on presence of remark
              >
                <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
                  {dayjs(remark.datetime).format("MMM D, YYYY h:mm A")}
                </p>
                <div
                  style={{
                    border: "1px solid #e8e8e8",
                    borderRadius: "8px",
                    padding: "10px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <p>
                    <strong style={{ fontSize: "17px" }}>
                      {remark?.user?.name}
                    </strong>
                  </p>
                  <p style={{ fontSize: "15px" }}>
                    {remark.remark || "No remark provided"}
                  </p>
                </div>
              </Timeline.Item>
            ))}
          </Timeline>
        </Scrollbars>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          borderTop: "1px solid #e8e8e8",
          paddingTop: 8,
        }}
      >
        <Input
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
          placeholder="Add Remarks"
          onKeyDown={handleKeyDown}
          style={{ flexGrow: 1, borderRadius: 8, borderColor: "#1890ff" }}
          suffix={
            <SendOutlined onClick={sendRemarks} style={{ color: "#A80038" }} />
          }
        />
      </div>
    </Card>
  );
};

export default Remarks;
